module.exports = __webpack_public_path__ + "assets/GTAmerica-ExtendedBlack.woff2";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExtendedBlack.woff2
// module id = 1009
// module chunks = 19